import React, { useState, useContext, useEffect } from 'react'
const refresh = () => {
  window.location.reload()
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: '',
      info: '',
    }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    console.log('something went wrong: ', error, info);
    this.setState({
      error: error,
      info: info
    })
    // logErrorToMyService(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // return this.props.fallback;
      return (
        <div className="sopa--map-error">
          <p><span className="material-icons nsw-material-icons">warning</span> An error has occurred.</p>
          <p>You may try <a href="#" onClick={refresh}>refreshing the page</a> or <a href="/">return to the home page</a>.</p>
        </div>
      )
    }
    return this.props.children;
  }
}

export default ErrorBoundary
